import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setOperatorMachine } from 'redux/actions/layoutActions';
import Machine from './Machine';

const mapStateToProps = ({ layout: { locale, admin } }) => ({ locale, admin });

const mapDispatchToProps = { setOperatorMachine };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Machine));
